import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取标签列表 get
 * @param query 分页参数
 * @return request
 * */
export function getLabelList(query) {
    return request({
        url: `${baseURL.businessApi}/labels`,
        method: 'get',
        params: query
    })
}

/**
 * 增加标签 post
 * @param data 增加的数据
 * @return request
 * */
export function addLabel(data) {
    return request({
        url: `${baseURL.businessApi}/labels`,
        method: 'post',
        data: data
    })
}

/**
 * 删除标签  delete
 * @param id 标签id
 * @return request
 * */
export function deleteLabel(id) {
    return request({
        url: `${baseURL.businessApi}/labels/${id}`,
        method: 'delete'
    })
}

/***
 * 修改标签 Post
 * @param id 要修改的标签id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateLabel(id, data) {
    return request({
        url: `${baseURL.businessApi}/labels/${id}`,
        method: 'post',
        data: data
    })
}